/** A refusal, from the API or from the card store on this device (local/store.ts) - same shape either way. */
export class ApiError extends Error {
  readonly status: number;
  readonly body: Record<string, any>;
  constructor(status: number, body: Record<string, any>) {
    super(body?.message || body?.error || `request failed (${status})`);
    this.status = status;
    this.body = body;
  }
}
